import OptionsCategory from './OptionsCategory'

export default OptionsCategory
